import { useMutation } from '@tanstack/react-query';

import type { AgentApiCompaniesMergeResult } from '@/types/serializers';

type MergeCompanyParams = {
  companyId: number;
  targetCompanyId: number;
};

export default function useMergeCompany() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation<AgentApiCompaniesMergeResult, Error, MergeCompanyParams>({
    mutationFn: async (params: MergeCompanyParams) => {
      const { companyId, targetCompanyId } = params;

      const response = await fetch(`/agent/api/companies/${companyId}/merge`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ target_company_id: targetCompanyId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.join(', ') || '統合に失敗しました');
      }

      const data = await response.json();
      return data;
    },
  });
}
